// Sugar Alarm — the one "make this file croppable" step (cycle 87/105,
// shared since cycle 457).
//
// iPhones default to HEIC, which most browsers can't decode to a canvas
// (Safari can; desktop Chrome/Firefox can't). HEIC/HEIF is converted to a
// JPEG Blob via `heic2any`, dynamically imported so it is code-split out of
// the main bundle and only fetched when a HEIC file is actually chosen.
// Every other format passes through unchanged into the cropper. The cropper
// re-encodes through a canvas, and since cycle 457 the server re-encodes
// again and strips every metadata block — this step only exists so the
// cropper can SHOW the picture.

export async function toCroppableBlob(file: File): Promise<Blob> {
  const isHeic =
    /image\/hei[cf]/i.test(file.type) || /\.hei[cf]$/i.test(file.name || "");
  if (!isHeic) return file;
  const heic2any = (await import("heic2any")).default;
  const out = await heic2any({ blob: file, toType: "image/jpeg", quality: 0.92 });
  const blob = Array.isArray(out) ? out[0] : out;
  if (!blob) throw new Error("heic conversion produced no output");
  return blob;
}

/** Was this file a HEIC/HEIF (so a conversion failure says so plainly)? */
export function isHeicFile(file: File): boolean {
  return /image\/hei[cf]/i.test(file.type) || /\.hei[cf]$/i.test(file.name || "");
}
